export default __webpack_public_path__ + "images/8f0ba554cc828206d0e1d151d4aea032.png";